import { TitleBar } from "./TitleBar";
import { TwoColumn } from "./TwoColumn";

interface IProps {
  title: string;
  header: string;
  element: JSX.Element;
  image: string;
  underlay?: string;
  className?: string;
  isReversed?: boolean;
  icon?: string;
}

export const ImageRow = ({
  title,
  header,
  element,
  image,
  underlay,
  className,
  isReversed,
  icon,
}: IProps) => {
  const imageHalf = (
    <div className={"flex relative md:p-10"}>
      {underlay && (
        <div
          className={`absolute top-0 w-3/4 h-3/4 hidden md:block opacity-75
                ${isReversed ? "right-0 -scale-x-100" : "left-0"}`}
          style={{ backgroundImage: `url(${underlay})` }}
        />
      )}
      <img
        className={
          "object-cover object-center z-10 w-full h-full md:rounded-lg shadow-lg md:shadow-2xl md:shadow-primary-500"
        }
        src={image}
        alt={image}
      />
    </div>
  );

  const contentHalf = (
    <div className={"items-center px-2 pt-8 md:px-10"}>
      <TitleBar title={title} header={header} icon={icon} isReversed={false} />
      {element}
    </div>
  );

  return (
    <TwoColumn
      left={imageHalf}
      right={contentHalf}
      isReversed={isReversed}
      className={`${className}`}
    />
  );
};
